export function DiagramToDocument(xml: string) {

  const parser = new DOMParser();
  const xmlDOM = parser.parseFromString(xml, 'text/xml');

  const tools = {
    getTask: (definitionKey: string) => {
      return xmlDOM.getElementById(definitionKey);
    },
    getTaskProperty: (definitionKey: string, propertyName: string) => {
      const task = tools.getTask(definitionKey);
      let property;
      if (task) {
        property = task.querySelector(`[name="${propertyName}"]`);
      }
      return property;
    },
    getTaskPropertiesValue: (definitionKey: string, properties: string[] = []) => {
      const task = tools.getTask(definitionKey) as HTMLElement;
      return properties.map(property => {
        const prop = task.querySelector(`[name="${property}"]`);
        if (prop) {
          return prop.getAttribute('value');
        }
      });
    },
    getStartEvent: () => {
      const startEvents = xmlDOM.getElementsByTagName('bpmn:startEvent');
      if (startEvents.length) {
        return startEvents[0].id;
      }
      return null;
    },
    getTimerDefinition: (definitionKey: string) => {
      const task = tools.getTask(definitionKey) as HTMLElement;
      const timer = task.getElementsByTagName('bpmn:timerEventDefinition');
      if (timer && timer.length && timer[0].children && timer[0].children.length) {
        return timer[0].children[0].textContent;
      }
      return null;
    },
  };

  return tools;
}
